import { BaseImage } from './base-image';

export class FillableImage extends BaseImage {

	filledText: string;
	correctTexts: string[] = [];

}
